import type { CSSProperties } from 'react';

/**
 * Typography-inheritance contract for inline markdown tokens.
 *
 * Block-level components own typographic scale. Inline tokens inherit size,
 * family, line-height, and letter-spacing so the parent container stays in
 * charge of visual rhythm.
 */
export const INLINE_INHERIT_TYPOGRAPHY_STYLE: CSSProperties = {
  fontSize: 'inherit',
  fontFamily: 'inherit',
  lineHeight: 'inherit',
  letterSpacing: 'inherit',
};
